<template>
  <div v-show="description != ''" class="caption-box" ref="captionBox" v-html="addLinksToText(description)"></div>
  <div v-show="description != '' && showReadMore" class="read-more-button-block">
    <div class="read-more-button" @click="openReadMore()">
      {{ $t('buttons.readmore') }}
    </div>
  </div>
</template>
<script>
import { defineComponent, nextTick } from "vue";
import { IonButton, modalController } from '@ionic/vue';
import ReadMoreModal from '@/components/ReadMoreModal.vue'
import { addLinksToText } from '@/composables/text';
import { arrowRedo } from 'ionicons/icons';

export default defineComponent({
  name: "PostDescription",
  props: {
    description: { String, default: '' },
    piklist_id: { Number, default: 0 },
    pik_id: { Number, default: 0 },
    pikd_pik_id: { Number, default: 0 },
    current_index: { Number, default: 0 },
    slider: { Number, default: 0 },
    text_only: { Number, default: 0 },
    originator_id: { Number, default: 0 },
    originator_username: { String, default: '' }
  },
  components: {
    IonButton
  },
  setup() {
    return { addLinksToText, arrowRedo }
  },
  data() {
    return {
      readMoreData: [],
      captionBoxData: null,
      showReadMore: false,
      readMoreClicked: false,
      captionBoxElement: null
    }
  },
  mounted() {
    let element = this.$refs['captionBox'];
    this.captionBoxElement = element;
    this.checkBoxSize();
    /* if(element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth){
      this.showReadMore = true;
    }else{
      this.showReadMore = false;
    }*/
  },
  methods: {
    checkReadMore(story, id) {
      // console.log(this.readMoreData, 'read more data');
      var isChecked = false;
      var variable = story + "|" + id;
      //console.log(variable, 'variable');
      //console.log(this.readMoreData, 'readmore array');
      for (var i = 0; i < this.readMoreData.length; i++) {
        if (this.readMoreData[i] == variable) {
          isChecked = true;
        }
      }
      return isChecked;
    },
    /* readMore(story, id) {
      this.readMoreData.push(story + "|" + id);
      this.$emit('update:heightRefresh', 1);  
      
      console.log(this.$refs['captionBox'].class, 'height');
      //this.$refs['captionBox'].clientHeight = '400';
      console.log(this.$refs['captionBox'].clientHeight, 'after height');
      this.showReadMore = false;
      this.readMoreClicked = true;
      
    }, */
    async openReadMore() {
      const modal = await modalController
        .create({
          component: ReadMoreModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: '@' + this.originator_username,
            description: this.description
          }
        })
      await modal.present();
      /* let dismissed = await modal.onDidDismiss();
      if(dismissed!=undefined){
        this.doRefresh('mounted');
      }*/

    },
    /* captionStyle(description){
      let style = 'caption-box'
      if(description.length<100 && this.text_only==1){
        style = 'caption-large caption-box'
      }
      return style;
    }, 
    boxSize(){
      //console.log('change box size');
      let boxCss = 'caption-box';
      if(this.readMoreClicked){
        boxCss = 'caption-box read-more';
      }
      if(this.pikd_pik_id != 0 && this.pikd_pik_id != null){
        boxCss = 'caption-box-repost';
      } 
      return boxCss;
    }, */
    async checkBoxSize() {
      if (this.description != '') {
        await nextTick();
        let element = this.captionBoxElement;
        if (element != null) {
          if (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) {
            //console.log(this.description, 'it does not fit');
            this.showReadMore = true;
          } else {
            //console.log(this.description, 'it fits');
            this.showReadMore = false;
          }
        } else {
          //console.log('no box');
          this.showReadMore = false;
        }
      } else {
        //console.log('no description');
        this.showReadMore = false;

      }
    }
  },
  watch: {
    description() {
      this.checkBoxSize();
    }
  }
});
</script>
